// import React, { useState, useEffect } from 'react';
// import { useHistory } from 'react-router-dom';
// import { fetchData } from '../../../apiService';
// import { useAuth } from '../../../AuthContext';
// import { tokenIsExpired } from '../../../authUtils';

// const MonthlyAttendancePage = () => {
//     const history = useHistory();
//     const { isAuthenticated, companyId, logout, token } = useAuth();

//     const [selectedMonth, setSelectedMonth] = useState(() => {
//         const now = new Date();
//         return `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}`; // YYYY-MM
//     });

//     const [staffData, setStaffData] = useState([]);
//     const [currentMonthDates, setCurrentMonthDates] = useState([]);

//     const statusShortCode = {
//         Present: 'P',
//         Leave: 'L',
//         'Half-day': 'HD',
//         Holiday: 'H',
//         'Half-day LOP': 'H-LOP',
//         LOP: 'LOP',
//     };

//     useEffect(() => {
//         if (isAuthenticated && tokenIsExpired(token)) {
//             logout();
//             return;
//         }

//         const [year, month] = selectedMonth.split('-').map(Number);
//         const dates = getMonthDates(year, month - 1);
//         setCurrentMonthDates(dates);
//         fetchMonthlyAttendance(year, month);
//     }, [isAuthenticated, companyId, token, logout, selectedMonth]);

//     const fetchMonthlyAttendance = async (year, month) => {
//         try {
//             const response = await fetchData('AttendanceSheetApi', `/AttendanceDateWiseList/${companyId}`, token);

//             if (response.responseCode === '1111') {
//                 const grouped = {};

//                 response.response_data.forEach((entry) => {
//                     const { staffId, staffName, attendanceStatusName, attendanceDate: rawDate } = entry;

//                     if (!rawDate || !attendanceStatusName) return;

//                     const dateObj = new Date(rawDate);
//                     const entryYear = dateObj.getFullYear();
//                     const entryMonth = dateObj.getMonth() + 1;

//                     // Only consider entries from selected month
//                     if (entryYear !== year || entryMonth !== month) return;

//                     const attendanceDate = dateObj.toLocaleDateString('en-CA'); // 'YYYY-MM-DD'

//                     if (!grouped[staffId]) {
//                         grouped[staffId] = {
//                             id: staffId,
//                             staffName,
//                             attendance: {},
//                         };
//                     }

//                     grouped[staffId].attendance[attendanceDate] = statusShortCode[attendanceStatusName] || '';
//                 });

//                 setStaffData(Object.values(grouped));
//             }
//         } catch (error) {
//             console.error('Error fetching Attendance Sheet:', error);
//         }
//     };

//     const getMonthDates = (year, month) => {
//         const dates = [];
//         const daysInMonth = new Date(year, month + 1, 0).getDate();

//         for (let day = 1; day <= daysInMonth; day++) {
//             const date = new Date(year, month, day);
//             const dayName = date.toLocaleDateString('en-US', { weekday: 'short' });
//             const dateStr = date.toLocaleDateString('en-CA'); // YYYY-MM-DD
//             const dayLabel = `${String(day).padStart(2, '0')}-${dayName}`;
//             dates.push({ date: dateStr, label: dayLabel });
//         }

//         return dates;
//     };

//     return (
//         <div className="min-h-screen bg-gray-100 py-10 px-4" style={{ width: '100%' }}>
//             <div className="flex items-center justify-center mb-6 max-w-6xl mx-auto relative">
//                 <h6 className="text-indigo-600 font-semibold uppercase text-base text-center w-full">
//                     Staff Attendance
//                 </h6>

//                 <div className="absolute right-0">
//                     <input
//                         type="month"
//                         value={selectedMonth}
//                         onChange={(e) => setSelectedMonth(e.target.value)}
//                         className="border border-gray-300 rounded px-2 py-1 text-sm"
//                     />
//                 </div>
//             </div>


//             <div className="overflow-x-auto rounded-xl border border-gray-200" style={{ fontSize: '12px' }}>
//                 <table className="min-w-full table-auto text-sm">
//                     <thead className="bg-indigo-100 text-gray-700 text-left sticky top-0">
//                         <tr>
//                             <th
//                                 style={{
//                                     fontWeight: 'bold',
//                                     textTransform: 'uppercase',
//                                     padding: '5px',
//                                     fontSize: '12px',
//                                 }}
//                             >
//                                 Staff
//                             </th>
//                             {currentMonthDates.map((dateObj) => (
//                                 <th
//                                     key={dateObj.date}
//                                     style={{
//                                         fontWeight: 'bold',
//                                         padding: '5px',
//                                         whiteSpace: 'nowrap',
//                                         fontSize: '11px',
//                                     }}
//                                 >
//                                     {dateObj.label}
//                                 </th>
//                             ))}
//                         </tr>
//                     </thead>
//                     <tbody>
//                         {staffData.map((staff) => (
//                             <tr key={staff.id} className="border-b border-gray-200 hover:bg-gray-50 transition">
//                                 <td
//                                     style={{
//                                         fontWeight: 'bold',
//                                         textTransform: 'uppercase',
//                                         padding: '5px',
//                                         fontSize: '10px',
//                                     }}
//                                 >
//                                     {staff.staffName}
//                                 </td>

//                                 {currentMonthDates.map((dateObj) => (
//                                     <td
//                                         key={`${staff.id}-${dateObj.date}`}
//                                         style={{
//                                             padding: '5px',
//                                             fontSize: '10px',
//                                             textAlign: 'center',
//                                             fontWeight: 'bold',
//                                             color:
//                                                 staff.attendance[dateObj.date] === 'P' ? 'green' :
//                                                     staff.attendance[dateObj.date] === 'L' ? 'red' :
//                                                         staff.attendance[dateObj.date] === 'HD' ? 'darkgoldenrod' :
//                                                             staff.attendance[dateObj.date] === 'H' ? 'brown' :
//                                                              staff.attendance[dateObj.date] === 'H-LOP' ? 'orange' :
//                                                               staff.attendance[dateObj.date] === 'LOP' ? '#8A0000' :
//                                                                 'black'
//                                         }}
//                                     >
//                                         {staff.attendance[dateObj.date] || '-'}
//                                     </td>

//                                 ))}

//                             </tr>
//                         ))}
//                     </tbody>
//                 </table>
//             </div>
//         </div>
//     );
// };

// export default MonthlyAttendancePage;

import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { fetchData } from '../../../apiService';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver'; // optional but useful

const MonthlyAttendancePage = () => {
    const history = useHistory();
    const { isAuthenticated, companyId, logout, token } = useAuth();

    const [selectedMonth, setSelectedMonth] = useState(() => {
        const now = new Date();
        return `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}`; // YYYY-MM
    });

    const [staffData, setStaffData] = useState([]);
    const [currentMonthDates, setCurrentMonthDates] = useState([]);

    const statusShortCode = {
        Present: 'P',
        Leave: 'L',
        'Half-day': 'HD',
        Holiday: 'H',
        'Half-day LOP': 'H-LOP',
        LOP: 'LOP',
    };

    useEffect(() => {
        if (isAuthenticated && tokenIsExpired(token)) {
            logout();
            return;
        }

        const [year, month] = selectedMonth.split('-').map(Number);
        const dates = getMonthDates(year, month - 1);
        setCurrentMonthDates(dates);
        fetchMonthlyAttendance(year, month);
    }, [isAuthenticated, companyId, token, logout, selectedMonth]);

    const fetchMonthlyAttendance = async (year, month) => {
        try {
            const response = await fetchData('AttendanceSheetApi', `/AttendanceDateWiseList/${companyId}`, token);

            if (response.responseCode === '1111') {
                const grouped = {};

                response.response_data.forEach((entry) => {
                    const { staffId, staffName, attendanceStatusName, attendanceDate: rawDate } = entry;

                    if (!rawDate || !attendanceStatusName) return;

                    const dateObj = new Date(rawDate);
                    const entryYear = dateObj.getFullYear();
                    const entryMonth = dateObj.getMonth() + 1;

                    if (entryYear !== year || entryMonth !== month) return;

                    const attendanceDate = dateObj.toLocaleDateString('en-CA'); // YYYY-MM-DD

                    if (!grouped[staffId]) {
                        grouped[staffId] = {
                            id: staffId,
                            staffName,
                            attendance: {},
                            totalLeave: 0,
                            totalHalfDay: 0,
                            totalLOP: 0,
                            totalHalfDayLOP: 0,
                        };
                    }

                    const code = statusShortCode[attendanceStatusName] || '';
                    grouped[staffId].attendance[attendanceDate] = code;

                    if (code === 'L') grouped[staffId].totalLeave += 1;
                    else if (code === 'HD') grouped[staffId].totalHalfDay += 1;
                    else if (code === 'LOP') grouped[staffId].totalLOP += 1;
                    else if (code === 'H-LOP') grouped[staffId].totalHalfDayLOP += 1;
                });

                setStaffData(Object.values(grouped));
            }
        } catch (error) {
            console.error('Error fetching Attendance Sheet:', error);
        }
    };

    const getMonthDates = (year, month) => {
        const dates = [];
        const daysInMonth = new Date(year, month + 1, 0).getDate();

        for (let day = 1; day <= daysInMonth; day++) {
            const date = new Date(year, month, day);
            const dayName = date.toLocaleDateString('en-US', { weekday: 'short' });
            const dateStr = date.toLocaleDateString('en-CA'); // YYYY-MM-DD
            const dayLabel = `${String(day).padStart(2, '0')}-${dayName}`;
            dates.push({ date: dateStr, label: dayLabel });
        }

        return dates;
    };

    const exportToExcel = () => {
        const headers = ['Staff', ...currentMonthDates.map(d => d.label), 'Leave', 'Half-Day', 'LOP', 'Half-day LOP'];
        const data = staffData.map((staff) => {
            const row = [staff.staffName];

            currentMonthDates.forEach(dateObj => {
                row.push(staff.attendance[dateObj.date] || '-');
            });

            row.push(
                staff.totalLeave,
                staff.totalHalfDay,
                staff.totalLOP,
                staff.totalHalfDayLOP
            );

            return row;
        });

        const worksheet = XLSX.utils.aoa_to_sheet([headers, ...data]);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Attendance');

        XLSX.writeFile(workbook, `Attendance_${selectedMonth}.xlsx`);
    };


    return (
        <div className="min-h-screen bg-gray-100 py-10 px-4" style={{ width: '100%' }}>
            {/* <div className="flex items-center justify-center mb-6 max-w-6xl mx-auto relative">
                <h6 className="text-indigo-600 font-semibold uppercase text-base text-center w-full">
                    Staff Attendance
                </h6>

                <div className="absolute right-0">
                    <input
                        type="month"
                        value={selectedMonth}
                        onChange={(e) => setSelectedMonth(e.target.value)}
                        className="border border-gray-300 rounded px-2 py-1 text-sm"
                    />
                </div>
                <div className="mb-4 flex justify-end max-w-6xl mx-auto">
                    <button
                        onClick={exportToExcel}
                        className="bg-green-600 hover:bg-green-700 text-white px-4 py-1 rounded text-sm"
                    >
                        Export to Excel
                    </button>
                </div>

            </div> */}
            <div className="flex items-center justify-between mb-6 max-w-6xl mx-auto relative">
                <h6 className="text-indigo-600 font-semibold uppercase text-base text-center w-full">
                    Staff Attendance
                </h6>

                {/* Month Input and Export Button */}
                <div className="absolute right-0 flex space-x-2">
                    <input
                        type="month"
                        value={selectedMonth}
                        onChange={(e) => setSelectedMonth(e.target.value)}
                        className="border border-gray-300 rounded px-2 py-1 text-sm"
                    />
                    <button style={{ marginLeft: '5px' }}
                        onClick={exportToExcel}
                        className="bg-green-600 hover:bg-green-700 text-white px-4 py-1 rounded text-sm"
                    >
                        Excel
                    </button>
                </div>
            </div>


            <div className="overflow-x-auto rounded-xl border border-gray-200" style={{ fontSize: '12px' }}>
                <table className="min-w-full table-auto text-sm">
                    <thead className="bg-indigo-100 text-gray-700 text-left sticky top-0">
                        <tr>
                            <th style={{ fontWeight: 'bold', textTransform: 'uppercase', padding: '5px', fontSize: '12px' }}>
                                Staff
                            </th>
                            {currentMonthDates.map((dateObj) => (
                                <th
                                    key={dateObj.date}
                                    style={{ fontWeight: 'bold', padding: '5px', whiteSpace: 'nowrap', fontSize: '11px' }}
                                >
                                    {dateObj.label}
                                </th>
                            ))}
                            <th style={{ fontWeight: 'bold', padding: '5px', fontSize: '12px' }}>Leave</th>
                            <th style={{ fontWeight: 'bold', padding: '5px', fontSize: '12px' }}>Half-Day</th>
                            <th style={{ fontWeight: 'bold', padding: '5px', fontSize: '12px' }}>LOP</th>
                            <th style={{ fontWeight: 'bold', padding: '5px', fontSize: '12px' }}>Half-day LOP</th>
                        </tr>
                    </thead>
                    <tbody>
                        {staffData.map((staff) => (
                            <tr key={staff.id} className="border-b border-gray-200 hover:bg-gray-50 transition">
                                <td
                                    style={{
                                        fontWeight: 'bold',
                                        textTransform: 'uppercase',
                                        padding: '5px',
                                        fontSize: '10px',
                                    }}
                                >
                                    {staff.staffName}
                                </td>

                                {currentMonthDates.map((dateObj) => (
                                    <td
                                        key={`${staff.id}-${dateObj.date}`}
                                        style={{
                                            padding: '5px',
                                            fontSize: '10px',
                                            textAlign: 'center',
                                            fontWeight: 'bold',
                                            color:
                                                staff.attendance[dateObj.date] === 'P' ? 'green' :
                                                    staff.attendance[dateObj.date] === 'L' ? 'red' :
                                                        staff.attendance[dateObj.date] === 'HD' ? 'darkgoldenrod' :
                                                            staff.attendance[dateObj.date] === 'H' ? 'brown' :
                                                                staff.attendance[dateObj.date] === 'H-LOP' ? 'orange' :
                                                                    staff.attendance[dateObj.date] === 'LOP' ? '#8A0000' :
                                                                        'black',
                                        }}
                                    >
                                        {staff.attendance[dateObj.date] || '-'}
                                    </td>
                                ))}

                                <td style={{ textAlign: 'center', fontWeight: 'bold', color: 'red' }}>
                                    {staff.totalLeave}
                                </td>
                                <td style={{ textAlign: 'center', fontWeight: 'bold', color: 'darkgoldenrod' }}>
                                    {staff.totalHalfDay}
                                </td>
                                <td style={{ textAlign: 'center', fontWeight: 'bold', color: '#8A0000' }}>
                                    {staff.totalLOP}
                                </td>
                                <td style={{ textAlign: 'center', fontWeight: 'bold', color: 'orange' }}>
                                    {staff.totalHalfDayLOP}
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default MonthlyAttendancePage;

